import Model from "./model";

export default new Model({
  resource : "sub-labor",
  grouped : true,
  inputs:[
    {label:"ID", nameAttr:"id", default:0, required: true, type:"text", width: 60},
    {label:"Nombre", nameAttr:"nombre", default:"", required: true, type:"text", width: 300},
    {label:"Código", nameAttr:"codigo", default:"-", required: true, type:"text", width: 100},
    {label:"C. Agro", nameAttr:"compuagro_id", default:"", required:false, type:"text", width: 100},
    {label:"Precio Unidad", nameAttr:"precio", default:0, required: true, type:"text", width: 100},
    {label:"Descripción", nameAttr:"descripcion", default:"-", required: false, type:"text", width: 300},
    {label:"Agregar Código", nameAttr:"agregar_codigo", default:false, required: true, type:"checkbox", width: 60},
    {label:"Semana Corrida", nameAttr:"semana_corrida", default:false, required: true, type:"checkbox", width: 60},
    {label:"Familia Labor", nameAttr:"labor_id", default:null, required: true, type:"select", model:"laborModel", searchPath: "nombre", width: 250},
    {label:"Unidad", nameAttr:"unidad_id", default:null, required: true, type:"select", model:"unidadModel", searchPath: "nombre", width: 150},
    //{label:"Empresa", nameAttr:"empresa_id", default:0, required: true, type:"select", model:"empresaModel"},
  ]
});
